// Integer trigonometry for deterministic geometry: SIN_1E6[d] = round(sin(d deg) * 1e6).
// Literal table (generated once) so no engine-dependent Math.sin results reach game state.

export const SIN_1E6: readonly number[] = [
  0, 17452, 34899, 52336, 69756, 87156, 104528, 121869, 139173, 156434, 173648, 190809,
  207912, 224951, 241922, 258819, 275637, 292372, 309017, 325568, 342020, 358368, 374607, 390731,
  406737, 422618, 438371, 453990, 469472, 484810, 500000, 515038, 529919, 544639, 559193, 573576,
  587785, 601815, 615661, 629320, 642788, 656059, 669131, 681998, 694658, 707107, 719340, 731354,
  743145, 754710, 766044, 777146, 788011, 798636, 809017, 819152, 829038, 838671, 848048, 857167,
  866025, 874620, 882948, 891007, 898794, 906308, 913545, 920505, 927184, 933580, 939693, 945519,
  951057, 956305, 961262, 965926, 970296, 974370, 978148, 981627, 984808, 987688, 990268, 992546,
  994522, 996195, 997564, 998630, 999391, 999848, 1000000, 999848, 999391, 998630, 997564, 996195,
  994522, 992546, 990268, 987688, 984808, 981627, 978148, 974370, 970296, 965926, 961262, 956305,
  951057, 945519, 939693, 933580, 927184, 920505, 913545, 906308, 898794, 891007, 882948, 874620,
  866025, 857167, 848048, 838671, 829038, 819152, 809017, 798636, 788011, 777146, 766044, 754710,
  743145, 731354, 719340, 707107, 694658, 681998, 669131, 656059, 642788, 629320, 615661, 601815,
  587785, 573576, 559193, 544639, 529919, 515038, 500000, 484810, 469472, 453990, 438371, 422618,
  406737, 390731, 374607, 358368, 342020, 325568, 309017, 292372, 275637, 258819, 241922, 224951,
  207912, 190809, 173648, 156434, 139173, 121869, 104528, 87156, 69756, 52336, 34899, 17452,
  0, -17452, -34899, -52336, -69756, -87156, -104528, -121869, -139173, -156434, -173648, -190809,
  -207912, -224951, -241922, -258819, -275637, -292372, -309017, -325568, -342020, -358368, -374607, -390731,
  -406737, -422618, -438371, -453990, -469472, -484810, -500000, -515038, -529919, -544639, -559193, -573576,
  -587785, -601815, -615661, -629320, -642788, -656059, -669131, -681998, -694658, -707107, -719340, -731354,
  -743145, -754710, -766044, -777146, -788011, -798636, -809017, -819152, -829038, -838671, -848048, -857167,
  -866025, -874620, -882948, -891007, -898794, -906308, -913545, -920505, -927184, -933580, -939693, -945519,
  -951057, -956305, -961262, -965926, -970296, -974370, -978148, -981627, -984808, -987688, -990268, -992546,
  -994522, -996195, -997564, -998630, -999391, -999848, -1000000, -999848, -999391, -998630, -997564, -996195,
  -994522, -992546, -990268, -987688, -984808, -981627, -978148, -974370, -970296, -965926, -961262, -956305,
  -951057, -945519, -939693, -933580, -927184, -920505, -913545, -906308, -898794, -891007, -882948, -874620,
  -866025, -857167, -848048, -838671, -829038, -819152, -809017, -798636, -788011, -777146, -766044, -754710,
  -743145, -731354, -719340, -707107, -694658, -681998, -669131, -656059, -642788, -629320, -615661, -601815,
  -587785, -573576, -559193, -544639, -529919, -515038, -500000, -484810, -469472, -453990, -438371, -422618,
  -406737, -390731, -374607, -358368, -342020, -325568, -309017, -292372, -275637, -258819, -241922, -224951,
  -207912, -190809, -173648, -156434, -139173, -121869, -104528, -87156, -69756, -52336, -34899, -17452,
];

/** round(sin(deg) * 1e6) for any integer degree. */
export function sin1e6(deg: number): number {
  return SIN_1E6[((deg % 360) + 360) % 360];
}

/** round(cos(deg) * 1e6) for any integer degree. */
export function cos1e6(deg: number): number {
  return SIN_1E6[(((deg + 90) % 360) + 360) % 360];
}

// Native integer trigonometry (libg 0x1294440 / 0x1295174) [STAT]: int16 table of
// sin(deg)*1024 for 0..90 at libg 0x34335a (work/native/sin_table_1024.txt).
const SIN_1024: readonly number[] = [
  0, 18, 36, 54, 71, 89, 107, 125, 143, 160, 178, 195, 213, 230, 248, 265, 282, 299, 316, 333, 350, 367, 384, 400,
  416, 433, 449, 465, 481, 496, 512, 527, 543, 558, 573, 587, 602, 616, 630, 644, 658, 672, 685, 698, 711, 724,
  737, 749, 761, 773, 784, 796, 807, 818, 828, 839, 849, 859, 868, 878, 887, 896, 904, 912, 920, 928, 935, 943,
  949, 956, 962, 968, 974, 979, 984, 989, 994, 998, 1002, 1005, 1008, 1011, 1014, 1016, 1018, 1020, 1022, 1023,
  1023, 1024, 1024,
];

/** sin(deg) * 1024 exactly as 0x1294440: deg mod 360 (C remainder, then +360 if negative). */
export function sin1024(deg: number): number {
  let u = deg % 360;
  if (u < 0) u += 360;
  const a = u < 180 ? u : u - 180;
  const i = a < 91 ? a : 180 - a;
  return u < 180 ? SIN_1024[i] : -SIN_1024[i];
}

/** Rotate (x, y) by deg as 0x1295174: components (cos·x − sin·y)/1024, (sin·x + cos·y)/1024, truncated. */
export function rotate1024(x: number, y: number, deg: number): [number, number] {
  const c = sin1024(deg + 90);
  const s = sin1024(deg);
  return [Math.trunc((c * x - s * y) / 1024), Math.trunc((s * x + c * y) / 1024)];
}

/** atan(i / 128) in whole degrees for i = 0..128: the int8 table at libg 0x3432d8. */
const ATAN_DEG: readonly number[] = [
  0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 13, 13, 14, 14, 14,
  15, 15, 16, 16, 17, 17, 17, 18, 18, 19, 19, 19, 20, 20, 21, 21, 21, 22, 22, 22, 23, 23, 24, 24, 24, 25, 25, 25, 26,
  26, 27, 27, 27, 28, 28, 28, 29, 29, 29, 30, 30, 30, 31, 31, 31, 32, 32, 32, 33, 33, 33, 34, 34, 34, 35, 35, 35, 35,
  36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 39, 39, 39, 39, 40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43,
  43, 44, 44, 44, 44, 45, 45, 45,
];

/**
 * Angle of the vector (x, y) in whole degrees 0..359 (0 = +x, 90 = +y), integer math exactly as
 * 0x12946d4 (reached through 0x1294e04 on a facing vector) [STAT].
 */
export function angleOf(x: number, y: number): number {
  if (x === 0 && y === 0) return 0;
  const t = Math.trunc;
  if (x > 0 && y >= 0) return y < x ? ATAN_DEG[t((y << 7) / x)] : 90 - ATAN_DEG[t((x << 7) / y)];
  const ax = x < 0 ? -x : x;
  if (x < 1 && y > 0) return ax < y ? ATAN_DEG[t((ax << 7) / y)] + 90 : 180 - ATAN_DEG[t((y << 7) / ax)];
  const ay = y < 0 ? -y : y;
  if (x >= 0 || y > 0) {
    if (ax < ay) return ATAN_DEG[t((ax << 7) / ay)] + 270;
    if (x === 0) return 0;
    let v = 360 - ATAN_DEG[t((ay << 7) / ax)];
    if (v > 359) v = -ATAN_DEG[t((ay << 7) / ax)];
    return v < 0 ? v + 360 : v;
  }
  if (ay < ax) return ATAN_DEG[t((ay << 7) / ax)] + 180;
  if (y !== 0) return 270 - ATAN_DEG[t((ax << 7) / ay)];
  return 0;
}
